import { render, staticRenderFns } from "./TransferFilters.vue?vue&type=template&id=2000d763&scoped=true"
import script from "./TransferFilters.vue?vue&type=script&lang=js"
export * from "./TransferFilters.vue?vue&type=script&lang=js"
import style0 from "./TransferFilters.vue?vue&type=style&index=0&id=2000d763&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2000d763",
  null
  
)

export default component.exports